module.exports = require('./upper-case');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/string/uc.js
// module id = 234
// module chunks = 0